<template>
  <div class="container">
    <div class="condition">
      <el-page-header @back="goBack" :content="content" style="margin-bottom: 20px;">
      </el-page-header>
      <el-form :model="form" ref="form" label-width="100px">
        <el-form-item label="编排类型：" id="arrangetype">
          <el-select v-model="arrangeTypeValue" @change="getIntegrationAll">
            <el-option v-for="(item, index) in arrangeType"
                       :key="index"
                       :label="item.label"
                       :value="item.value">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="选择集成：" id="arrangeintegration">
          <el-select
            v-model="form.integrationId"
            filterable
            :filter-method="filterIntergrationOption"
            @change="setCurrentIntergration">
            <el-option v-for="(item, index) in integrationListFilter"
                       :key="index" :label="item.alias + item.version" :value="item.id">
              <span style="float: left">{{ item.alias }}</span>
              <span style="float: right; color: #8492a6; font-size: 13px">
                                {{ item.version }}
                            </span>
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="模块/网元：" id="module">
          <el-select multiple placeholder=""
                     v-model="form.moduleTypes"
                     filterable
                     :filter-method="filterModuleList"
                     @change="selectModuleHandle"
                     @focus="selectFocus"
                     @remove-tag="removeMudle">
            <el-option v-for="(item, index) in moduleListFilter"
                       :key="index"
                       :label="item.moduleAlias"
                       :value="item.moduleVersionId">
              <span style="float: left">{{ item.moduleAlias }}</span>
              <span style="float: right; color: #8492a6; font-size: 13px">
                                {{ item.moduleVersion }}
                            </span>
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="项目名称："
                      prop="alias"
                      :rules="{required: true, message: '必填项', trigger: 'change'}">
          <el-input placeholder="请填写版本号"
                    style="width:75%;"
                    v-model="form.alias"></el-input>
        </el-form-item>
        <el-form-item label="版本号："
                      prop="version"
                      :rules="{required: true, message: '必填项'}">
          <el-input placeholder="请填写版本号"
                    style="width:75%;"
                    v-model="form.version" @change="verify"></el-input>
        </el-form-item>
        <!-- <el-form-item label="基础版本：">
            <el-select v-model="form.basicId">
                <el-option v-for="(item, index) in arrangeList" :key="index"
                    :label="item.alias" :value="item.id">
                    <span style="float: left">{{ item.alias }}</span>
                    <span style="float: right; color: #8492a6; font-size: 13px">
                        {{ item.version }}
                    </span>
                </el-option>
            </el-select>
        </el-form-item> -->
        <el-form-item label="基础版本：" v-if="params.type == 'upgrade'">
          <el-input style="width:75%;"
                    v-model="form.basicVersion" :disabled="true"></el-input>
        </el-form-item>
      </el-form>

      <h3>
        <div style="display: inline-block;" id="checkboxId">
          <div style="display: inline-block;margin-right:10px;">布局</div>
          <el-checkbox v-model="dragable"></el-checkbox>
        </div>

        <el-button id="saveBtn" @click="save" size="mini" type="primary" style="margin-left: 30px;">
          保存布局
        </el-button>
      </h3>

      <div v-if="form.id && showInsOperate">
        <el-row>
          <el-col :span="15" style="line-height: 40px;">
            <el-button type="primary" size="mini" @click="createInstance">创建实例</el-button>
            <el-button type="primary" size="mini" @click="download">下载</el-button>
            <el-button type="primary" size="mini" @click="allocate">配置</el-button>
          </el-col>
          <el-col :span="9">
            <el-input placeholder="搜索"></el-input>
          </el-col>

        </el-row>

        <el-row style="margin:20px 0;">
          <div>
            <list-item :item="listHeader" :showOperate="false" style="font-weight: bold;color: #909399;line-height:1;"/>
          </div>
          <div class="el-table__empty-block noneData" v-if="tables.length == 0">
            <span class="el-table__empty-text">暂无数据</span>
          </div>
          <div v-for="(item, idx) in tables.slice(0, currentPage*pageSize)"
               :key="item.id" v-else>
            <box-progress :persents="item.progs" :height="65">
              <list-item :item="item" :index="idx" style="height:40px;" @itemCallback="itemCallback"/>
            </box-progress>
          </div>
          <div style="text-align:center;">
            <i v-if="currentPage != pageTotal"
               @click="addPage('expand')"
               class="el-icon-arrow-down collapse"></i>

            <i v-if="currentPage > 1"
               @click="addPage('collapse')"
               class="el-icon-arrow-up collapse"></i>
          </div>
        </el-row>
      </div>
    </div>
    <drag id="layout"
          ref="dragRef"
          :dragable="dragable"
          :dragList.sync="selectModules"
          @delDragItem="delDragItem"
          @deviceShowCallback="deviceShowCallback"/>

    <device-list ref="deviceListRef"
                 v-if="showDevice"
                 :visible="showDevice"
                 :selectedRows="selectedRows"
                 :currentModule="currentModule"
                 @deviceCallback="deviceCallback"
                 @deviceDel="deviceDel"/>


    <!-- 废弃 -->
    <!-- <update-module v-if="updateModuleShow"
        :visible="updateModuleShow"
        :updates="updates"
        @callBack="updateCallback"/> -->
  </div>
</template>
<script>
import {Loading} from "element-ui";
import Drag from './Drag'
import ListItem from './ArrangeEditListItem'
import BoxProgress from "../common/BoxProgress.vue";
import UpdateModule from './UpdateModuleDialog'
import DeviceList from './DragDeviceList'

export default {
  name: 'ArrangeEdit',
  components: {Drag, ListItem, BoxProgress, UpdateModule, DeviceList},
  data: vm => ({
    params: {}, //路由参数
    arrangeList: [], //编排列表
    form: {
      id: '',
      basicId: '',
      basicVersion: '',
      version: '',
      alias: '',
      integrationId: '', //选择的集成id
      moduleTypes: [], //选择的模块id数组
      oldModuleTypes: [], //上一次选中网元/模块 id集合
      integrationVersionAlias: '',
      integrationVersionVersion: '',
    },
    integrationList: [], //集成列表
    moduleList: [], //模块列表
    moduleListFilter: [],
    dragable: false,
    dragRef: {
      width: 0,
      height: 0
    },

    selectModules: [], //布局中选择的模块/网元集合
    oldSelectModules: [], //保存布局后存一份布局的数据，用于比较布局是否改变

    //实例列表
    tables: [],
    pageSize: 5, //实例列表默认显示的个数
    currentPage: 1, //当前页码

    listHeader: {
      id: "ID",
      moduleType: "模块类型",
      operate: "操作",
      statusDesc: "状态描述",
      hideCheckbox: true,
    },

    arrangeType: [
      {
        label: '网元',
        value: 'netele'
      }, {
        label: '模块',
        value: 'module'
      }
    ],
    arrangeTypeValue: '',
    groupInfoList: [],

    connectState: false,
    reconnectTimes: 1, // 重连次数
    timeOutNum: null, // 定时器

    updateModuleShow: false, //替换版本
    updates: {},

    showDevice: false, //设备弹框
    selectedRows: [],
    selectModulesActiveIndex: 0, //当前操作的是哪个模块/网元
    delInsIds: [],
    integrationListFilter: []
  }),
  computed: {
    content() {
      let title = '创建页面'
      if (this.params && this.params.type == 'edit') {
        title = '编辑页面'
      } else if (this.params && this.params.type == 'upgrade') {
        title = '升级页面'
      }
      return title
    },
    total() {
      return this.tables.length
    },
    // 总共几页实例
    pageTotal() {
      if (this.total == 0) {
        return 1
      } else {
        const r = this.total % this.pageSize
        const q = parseInt(this.total / this.pageSize)
        return (q + (r > 0 ? 1 : 0))
      }
    },
    currentModule() {
      let model = this.selectModules[this.selectModulesActiveIndex]
      model.arrangeId = this.form.id
      return model
    },
    showInsOperate() {
      const strOld = JSON.stringify(this.oldSelectModules)
      const strNew = JSON.stringify(this.selectModules)
      if (strOld == strNew) {
        return true
      } else {
        return false
      }
    }
  },
  mounted() {
    this.params = this.$route.params;
    if (this.params && this.params.id) {
      this.findById(this.params.id)
    }
    // 所有的集成
    // this.getIntegrationAll()
    this.dragRef.width = this.$refs.dragRef.$el.clientWidth
    this.dragRef.height = this.$refs.dragRef.$el.clientHeight

    // this.testProcess()

    this.startArrangeDriver()
    this.initWebSocket()
  },
  methods: {
    verify() {
      if (!this.form.alias || !this.form.version) {
        return
      }
      let url = 'instance2/verify/' + this.form.alias + '/' + this.form.version

      this.$axios.get(this.baseUrl3 + url)
        .then(({data: {code, data, msg}}) => {
          if (data != -1) {
            // 校验不通过时，提示已有编排，是否需要加载原来的编排
            this.$confirm('该版本已存在，您可以新增或者在原版本上编辑。如果新增请重新输入版本号。', '提示', {
              confirmButtonText: '新增',
              cancelButtonText: '编辑',
              type: 'warning'
            }).then(() => {
              this.form.version = ''
            }).catch(() => {
              this.form.id = data
              this.findById(data)
            });
          } else {
            // 校验成功
          }
        })
        .catch(err => {
          console.log(err)
        })
    },
    goBack() {
      this.$router.push({
        path: 'arrangelist'
      })
    },
    // 获取编排详情
    findById(id) {
      let loading = Loading.service({
        fullscreen: true,
        text: "数据加载中..."
      });
      this.$axios.get(this.baseUrl3 + 'instance2/findById/' + id)
        .then(({data: {code, data, msg}}) => {
          if (code == 20000) {
            // this.$message.success('操作成功')
            this.form = Object.assign({}, this.form, data)
            this.renderTables(data.instances)

            // 如果是编辑或升级，查看当前是网元还是模块
            if (this.params.id) {
              this.arrangeTypeValue = data.modules[0].group ? 'netele' : 'module'
              this.getIntegrationAll(this.arrangeTypeValue)
            }
            data.modules.forEach(dataM => {
              dataM.moduleVersionId = dataM.moduleAlias + '_' + dataM.moduleVersion
            })
            this.selectModules = data.modules
            this.oldSelectModules = JSON.parse(JSON.stringify(data.modules))
            if (this.params.type == 'upgrade') {
              this.form.basicId = this.params.id
              this.form.basicVersion = data.version
              this.form.version = ''
            }

            if (this.moduleList && this.moduleList.length > 0) {
              this.selectModules.forEach(m => {
                const id = this.moduleList.filter(ml => ml.moduleAlias == m.moduleAlias && ml.moduleVersion == m.moduleVersion)[0].moduleVersionId
                this.form.moduleTypes.push(id)
              })
              this.form.oldModuleTypes = this.form.moduleTypes
            }


          } else {
            this.$message.error(msg)
          }
          loading.close()
        })
        .catch(err => {
          console.log(err)
          loading.close()
        })
    },
    // 网元选择框focus时，存储当前选中的值
    selectFocus() {
      this.form.oldModuleTypes = this.form.moduleTypes
    },
    // 移除模块
    removeMudle(moduleId) {
      const index = this.selectModules.findIndex(sm => sm.moduleVersionId == moduleId)
      if (index != -1) {
        this.selectModules.splice(index, 1)
      }
    },
    /*
    * 当前选择的网元/模块 类型 是否在布局中，如果存在，查看版本是否一致；
    *   如果版本相同，返回；
    *   如果版本不同，
    *       而且是新增操作，直接加入布局中；
    *       如果编辑操作，提示，是要更新还是直接加入
    */
    editSelect(modules) {
      const _this = this
      // 添加选项
      // for(let i=0; i < modules.length; i++){
      //     const len = this.selectModules.length
      //     let q = parseInt(len / 3)
      //     let r = len % 3
      //     let top  = ((q+1) * 0.02 + q * 0.2) * _this.dragRef.height
      //     let left = ((r+1) * 0.02 + r * 0.25) *  _this.dragRef.width
      //     const mt = modules[i]
      //     const moduleItem = _this.moduleList.filter(ml => ml.moduleVersionId == mt)[0]

      //     const index = _this.selectModules.findIndex(sm => sm.moduleAlias == moduleItem.moduleAlias)

      //     if(index != -1){
      //         if(moduleItem.moduleVersion == _this.selectModules[index].moduleVersion){
      //             continue
      //         }else{
      //             if(this.params.id){
      //                 // 提示要替换还是新增
      //                 let type = _this.arrangeTypeValue == 'netele' ? '网元' : '模块'
      //                 let str = '该' + type + '类型已存在，您是要替换原来的版本还是新增选中的版本？'
      //                 this.$confirm(str, '提示', {
      //                     confirmButtonText: '新增',
      //                     cancelButtonText: '替换',
      //                     type: 'warning'
      //                 }).then(() => {
      //                     _this._pushModule(top, left, moduleItem)
      //                 }).catch(() => {
      //                     // 将原来的模块/网元替换成新选择的
      //                     // _this.form.moduleTypes = _this.form.moduleTypes.filter(m => m != _this.selectModules[index].moduleVersionId)
      //                     _this.selectModules[index].moduleVersion = moduleItem.moduleVersion
      //                     _this.selectModules[index].moduleVersionId = moduleItem.moduleVersionId
      //                 });
      //             }else{
      //                 _this._pushModule(top, left, moduleItem)
      //             }
      //         }

      //     }else{
      //         _this._pushModule(top, left, moduleItem)
      //     }
      // }

      // 2020-11-30-start
      // form.oldModuleTypes和form.moduleTypes做差量，差出来的那个就是新增或删除的模块
      let mt = ''
      if (this.form.moduleTypes.length > this.form.oldModuleTypes.length) {
        mt = this.form.moduleTypes[this.form.moduleTypes.length - 1]
        const moduleItem = this.moduleList.filter(ml => ml.moduleVersionId == mt)[0]
        const index = this.selectModules.findIndex(sm => sm.moduleAlias == moduleItem.moduleAlias)
        if (index != -1) {
          if (moduleItem.moduleVersion == _this.selectModules[index].moduleVersion) {

          } else {
            if (this.params.id) {
              // 提示要替换还是新增
              let type = this.arrangeTypeValue == 'netele' ? '网元' : '模块'
              let str = '该' + type + '类型已存在，您是要替换原来的版本还是新增选中的版本？'
              this.$confirm(str, '提示', {
                confirmButtonText: '新增',
                cancelButtonText: '替换',
                type: 'warning'
              }).then(() => {
                this._pushModule(null, null, moduleItem)
              }).catch(() => {
                // 将原来的模块/网元替换成新选择的
                this.selectModules[index].moduleVersion = moduleItem.moduleVersion
                this.selectModules[index].moduleVersionId = moduleItem.moduleVersionId
                const idx = this.form.moduleTypes.findIndex(item => item.includes(moduleItem.moduleAlias))
                this.form.moduleTypes.splice(idx, 1)
              });
            } else {
              this._pushModule(null, null, moduleItem)
            }
          }
        } else {
          this._pushModule(null, null, moduleItem)
        }
      } else {
        this.form.oldModuleTypes.forEach(item => {
          const existModule = modules.some(m => item == m)
          if (!existModule) {
            _this.removeMudle(item)
          }
        })
      }
      // 2020-11-30-end

      // 移除选项
      // this.form.oldModuleTypes.forEach(item => {
      //     const existModule = modules.some( m => item == m)
      //     if(!existModule){
      //         _this.removeMudle(item)
      //     }
      // })
      this.form.oldModuleTypes = modules
    },
    // 选择的模块/网元改变时触发
    selectModuleHandle(modules) {
      // test-start
      this.editSelect(modules)
      return
      // test- end

      // if(this.params && this.params.id){
      //     // 是编辑
      //     this.editSelect(modules)
      //     return
      // }
      // const _this = this
      // // 添加选项
      // for(let i=0; i < modules.length; i++){
      //     let q = parseInt(i / 3)
      //     let r = i % 3
      //     let top  = ((q+1) * 0.02 + q * 0.2) * _this.dragRef.height
      //     let left = ((r+1) * 0.02 + r * 0.25) *  _this.dragRef.width
      //     const mt = modules[i]
      //     const moduleItem = _this.moduleList.filter(ml => ml.moduleVersionId == mt)[0]
      //     const hasExist = _this.selectModules.some(sm => sm.moduleAlias == moduleItem.moduleAlias && sm.moduleVersion == moduleItem.moduleVersion)
      //     if(hasExist){
      //         continue
      //     }
      //     _this.selectModules.push({
      //         isActive: false,
      //         top: top,
      //         left: left,
      //         width: (_this.dragRef.width * 0.25),
      //         height: (_this.dragRef.width * 0.2),
      //         moduleType: moduleItem.moduleType || moduleItem.moduleName,
      //         moduleAlias: moduleItem.moduleAlias,
      //         moduleVersionId: moduleItem.moduleVersionId,
      //         moduleVersion: moduleItem.moduleVersion,
      //         //分配的设备信息
      //         deviceInstalleds: [],
      //         id: moduleItem.id,
      //         group: _this.arrangeTypeValue == 'netele' ? true : false
      //     })
      // }
      // // 移除选项
      // this.form.oldModuleTypes.forEach(item => {
      //     const existModule = modules.some( m => item == m)
      //     if(!existModule){
      //         _this.removeMudle(item)
      //     }
      // })

      // this.form.oldModuleTypes = modules
    },
    _pushModule(top, left, moduleItem) {
      if (!top || !left) {
        const len = this.selectModules.length
        let q = parseInt(len / 3)
        let r = len % 3
        top = ((q + 1) * 0.02 + q * 0.2) * this.dragRef.height
        left = ((r + 1) * 0.02 + r * 0.25) * this.dragRef.width
      }

      this.selectModules.push({
        isActive: false,
        top: top,
        left: left,
        width: (this.dragRef.width * 0.25),
        height: (this.dragRef.width * 0.2),
        moduleType: moduleItem.moduleType || moduleItem.moduleName,
        moduleAlias: moduleItem.moduleAlias,
        moduleVersionId: moduleItem.moduleVersionId,
        moduleVersion: moduleItem.moduleVersion,
        //分配的设备信息
        deviceInstalleds: [],
        id: moduleItem.id,
        group: this.arrangeTypeValue == 'netele' ? true : false,
        hasServiceHelper: moduleItem.hasServiceHelper
      })

    },

    // 减少布局中模块的设备数量(需要删除对应的实例)
    insDel() {
      if (this.delInsIds.length == 0) {
        return
      }
      this.$axios
        .post(this.baseUrl3 + 'instance2/batch/del',
          this.delInsIds)
        .then(({data: {code, data, msg}}) => {
          if (code == 20000) {
            this.$emit('dialogClose')
          } else {
            this.$message.error(msg)
          }

        })
        .catch(err => {
          console.log(err)
        })
    },
    // 保存布局
    createLayout() {
      if (this.selectModules.length == 0) {
        this.$message.warning('请先选择网元')
        return
      }
      let unSelectDeviceArr = []
      this.selectModules.forEach(sm => {
        if (sm.deviceInstalleds.length == 0) {
          unSelectDeviceArr.push(sm.moduleAlias + '(' + sm.moduleVersion + ')')
        }
      })
      if (unSelectDeviceArr.length > 0) {
        let str = '<h3>以下网元未选择设备：</h3>'
        this.$alert(str + unSelectDeviceArr.join('<br>'), '提示', {
          dangerouslyUseHTMLString: true,
          confirmButtonText: '我知道了'
        });
        return
      }

      let model = {
        basicId: this.form.basicId,
        basicVersion: this.form.basicVersion,
        id: this.form.id,
        version: this.form.version,
        modules: this.selectModules,
        alias: this.form.alias,
        integrationVersionAlias: this.currentIntergration.alias,
        integrationVersionVersion: this.currentIntergration.version,
      }
      model.modules.forEach(item => {
        item.integrationVersionAlias = this.currentIntergration.alias
        item.integrationVersionVersion = this.currentIntergration.version
      })
      let url = this.baseUrl3 + 'instance2/create/layout'
      if (this.params && this.params.type == 'edit' || this.form.id) {
        url = this.baseUrl3 + 'instance2/edit/layout'
      }

      this.$axios.post(url, model)
        .then(({data: {code, data, msg}}) => {
          if (code == 20000) {
            this.$message.success('操作成功')
            this.form.id = this.form.id ? this.form.id : data
            this.oldSelectModules = JSON.parse(JSON.stringify(this.selectModules))

            // 删除设备上的实例
            this.insDel()
          } else {
            this.$message.error('操作失败,' + msg)
          }
        })
        .catch(err => {
          console.log(err)
        })
    },
    // 保存布局
    save() {
      this.$refs.form.validate(valid => {
        if (valid) {
          this.createLayout()
        } else {
          console.log('表单验证失败')
        }
      })

    },
    // 获取集成列表
    getIntegrationAll(val) {
      this.form.integrationId = ''
      this.form.moduleTypes = []
      this.selectModules = []

      let url = "integration/Version/findAll"
      if (val == 'netele') {
        url = "integration2/Version/findAll"
      }
      this.$axios
        .get(this.moduleUrl + url)
        .then(({data: {msg, data, code}}) => {
          if (code == 20000) {
            this.integrationList = data ? data : [];
            this.integrationListFilter = data ? data : []

            if (this.form.integrationVersionAlias && this.form.integrationVersionVersion) {
              this.currentIntergration = this.integrationList.filter(item => {
                return item.alias == this.form.integrationVersionAlias && item.version == this.form.integrationVersionVersion
              })[0]
              this.form.integrationId = this.currentIntergration.id
              this.getModuleList()
            }
          } else {
            this.$message({showClose: true, message: msg, type: "error"});
            console.log(msg);
          }
        }).catch(err => {
        console.log('获取集成-请求失败')
      });
    },

    setCurrentIntergration() {
      // 只能选择一个集成
      this.selectModules = []
      this.currentIntergration = this.integrationList.filter(item => item.id == this.form.integrationId)[0]

      this.form.alias = this.currentIntergration.alias
      this.form.version = this.currentIntergration.version
      this.verify()
      this.getModuleList()
    },
    getModuleList() {
      const _this = this
      this.form.moduleTypes = []
      let url = "integration/Version/" + this.currentIntergration.alias + "/" + this.currentIntergration.version
      if (this.arrangeTypeValue == 'netele') {
        url = "integration2/Version/findById/" + this.currentIntergration.id
      }
      this.$axios
        .get(this.moduleUrl + url)
        .then(({data: {msg, data, code}}) => {
          if (code === 20000) {
            if (this.arrangeTypeValue == 'netele') {
              // this.groupInfoList = data.groupInfoList ? data.groupInfoList : [];
              this.moduleList = []
              data.groupInfoList.forEach(ginfo => {
                _this.moduleList.push({
                  moduleType: ginfo.groupName,
                  moduleAlias: ginfo.groupAlias,
                  // moduleVersionId: ginfo.groupVersionId,
                  moduleVersionId: `${ginfo.groupAlias}_${ginfo.groupVersion}`,
                  moduleVersion: ginfo.groupVersion,
                })
              })
            } else {
              // this.moduleList = data.moduleList ? data.moduleList : [];
              this.moduleList = []
              data.moduleList.forEach(dataModule => {
                dataModule.moduleVersionId = dataModule.moduleAlias + '_' + dataModule.moduleVersion
              })
              this.moduleList = data.moduleList
            }
            // 如果是编辑，回显选择的模块/网元
            if (this.form.id) {
              this.selectModules.forEach(m => {
                const moduleFilter = this.moduleList.filter(ml => ml.moduleAlias == m.moduleAlias && ml.moduleVersion == m.moduleVersion)
                if (moduleFilter.length > 0) {
                  const id = moduleFilter[0].moduleVersionId
                  this.form.moduleTypes.push(id)
                }

              })
              this.form.oldModuleTypes = this.form.moduleTypes
            }
            this.moduleListFilter = [...this.moduleList]
          } else {
            this.$message({showClose: true, message: msg, type: "error"});
          }
        })
        .catch(error => {
          this.$message({
            showClose: true,
            message: "系统异常，查询失败",
            type: "error"
          });
          console.log(error);
        });
    },
    // 删除drag元素时，同步删除多选框选中的值
    delDragItem(id) {
      this.form.moduleTypes = this.form.moduleTypes.filter(fm => fm != id)
    },

    itemCallback() {

    },

    // 对表格数据重新排序
    sortTable(index) {
      const obj = this.tables[index]
      this.tables.splice(index, 1)
      this.tables.push(obj)
    },
    // 处理实例列表数据
    renderTables(data) {
      this.tables = []
      if (!data) {
        return
      }
      data.forEach((obj, index) => {
        let item = {
          status: {},
          progs: [],
        }
        if (obj.service) {
          item = {
            name: obj.service.name,
            status: {
              operation: {}
            },
            progs: []
          };
          if (!obj.service.status.operation) {
            obj.service.status.operation = {}
          }
          item.status = Object.assign({}, item.status, obj.service.status)


          if (item.status.value == 0) {
            if (item.status.progress == 9 || item.status.progress == 0 || item.status.progress == 1 || item.status.progress == 2) {
              item.progs = [{percent: item.status.percent, progress: item.status.progress}]
            }
          }
        }
        this.tables.push(Object.assign(item, obj));
      })
    },
    // 创建编排里的实例
    createInstance() {
      if (!this.form.id) {
        return
      }
      this.tables = []
      let loading = Loading.service({
        fullscreen: true,
        text: "数据加载中..."
      });
      this.$axios.get(this.baseUrl3 + 'instance2/batch/add/' + this.form.id)
        .then(({data: {code, data, msg}}) => {
          if (code == 20000) {
            this.$message.success('操作成功')
            this.renderTables(data)
            // data.forEach((obj, index) => {
            //     let item = {
            //         status: {},
            //         progs: []
            //     }
            //     if(obj.service){
            //         item = {
            //             name: obj.service.name,
            //             status: {
            //                 operation: {}
            //             },
            //             progs: []
            //         };
            //         if(!obj.service.status.operation){
            //             obj.service.status.operation = {}
            //         }
            //         item.status = Object.assign({}, item.status, obj.service.status)


            //         if(item.status.value == 0){
            //             if(item.status.progress == 9 || item.status.progress == 0 || item.status.progress == 1 || item.status.progress == 2){
            //                 item.progs = [{percent: item.status.percent, progress: item.status.progress}]
            //             }
            //         }
            //     }
            //     this.tables.push(Object.assign(item, obj));
            // })
            // this.initWebSocket()
          } else {
            this.$message.error('操作失败,' + msg)
          }
          loading.close()
        })
        .catch(err => {
          loading.close()
          console.log(err)
        })
    },
    download() {
      this.$axios.get(this.baseUrl3 + 'instance2/batch/download/' + this.form.id)
        .then(({data: {code, data, msg}}) => {
          if (code == 20000) {
            this.$message.success('下发任务成功，请耐心等待')
          } else {
            this.$message.error('操作失败,' + msg)
          }
        })
        .catch(err => {
          console.log(err)
        })
    },
    allocate() {
      this.$axios.get(this.baseUrl3 + 'instance2/batch/allocate/' + this.form.id)
        .then(({data: {code, data, msg}}) => {
          if (code == 20000) {
            this.$message.success('下发任务成功，请耐心等待')
          } else {
            this.$message.error('操作失败,' + msg)
          }
        })
        .catch(err => {
          console.log(err)
        })
    },

    addPage(type) {
      if (type == 'collapse') {
        this.currentPage = 1
      } else if (this.currentPage != this.pageTotal) {
        this.currentPage++
      }
    },

    /**
     * 连接websocket
     */
    initWebSocket() {
      //const url = this.baseUrl.split('http://')[1]
      //初始化weosocket
      //const wsuri = "ws://" + url + "instance";
      // let url = "";
      // let wsuri = "";

      // if (this.baseUrl3.indexOf('https://') != -1) {
      //   url = this.baseUrl3.split('https://')[1];
      //   wsuri = "wss://" + url + "instance";
      // } else {
      //   url = this.baseUrl3.split('http://')[1];
      //   //初始化weosocket
      //   wsuri = "ws://" + url + "instance";
      // }
      // this.websock = new WebSocket(wsuri);
      // this.websock.onmessage = this.websocketonmessage;
      // this.websock.onopen = this.websocketonopen;
      // this.websock.onerror = this.websocketonerror;
      // this.websock.onclose = this.websocketclose;
    },
    websocketonopen() {
      //连接建立之后执行send方法发送数据
      console.log("open");
      this.connectState = true;
    },
    websocketonerror() {
      //连接建立失败重连
      // webSocket 断开连接 连接状态 重置
      this.connectState = false;
      // 大于9 次, 不再重连
      if (this.reconnectTimes <= 9) {
        this.reconnect();
      }
    },
    websocketonmessage(e) {
      //数据接收
      if (e) {
        // 获取到的对象不为空
        if (e.data != null && Object.keys(e.data).length != 0) {
          let data = JSON.parse(e.data);
          console.log('编排-websocket-message:')
          console.log(data)
          //   this.updateWebsocket(data)
          const _this = this
          let tr
          for (let i = 0; i < _this.tables.length; i++) {
            tr = _this.tables[i]
            if (tr.id == data.insId) {
              const progress = data.progress
              const value = data.value
              const percent = data.percent

              let item = {
                status: data,
                name: data.name, //推送的服务名称
              }
              // 建立依赖成功后，改变editDep为true
              if (progress == 8 && value == 1) {
                _this.tables[i].editDep = true
              }

              // 进度条渲染条件：1.配置过程中
              if (progress == 9) {
                item.progs = [{percent: percent, progress: progress}]
              }
              // 进度条渲染条件：2.安装过程
              if (progress == 2 || progress == 0 || progress == 1 || progress == 3) {
                if (_this.tables[i].progs.length == 0) {
                  item.progs = [{percent: percent, progress: progress}]
                } else {
                  item.progs = _this.tables[i].progs
                  let progressExist = false
                  for (let j = 0; j < item.progs.length; j++) {
                    if (item.progs[j].progress == progress) {
                      progressExist = true
                      item.progs[j].percent = percent
                      break
                    }
                  }
                  if (!progressExist) {
                    item.progs.push({
                      percent: percent,
                      progress: progress
                    })
                  }
                }
              }

              // 实例下载过程
              if (progress == 19) {
                item.progs = [{percent: percent, progress: progress}]
              }


              _this.$set(_this.tables, i, Object.assign(tr, item))

              if (percent == 100) {
                _this.sortTable(i)
              }

              break
            }
          }
        }
      }
    },
    websocketclose(e) {
      //关闭
      console.log("断开连接", e);
      this.connectState = false;
      // 大于9 次, 不再重连
      if (this.reconnectTimes <= 9) {
        this.reconnect();
      }
    },
    /**
     * 断线重连
     */
    reconnect() {
      // 连接断开时, 进行重连
      if (!this.connectState) {
        // 连接次数
        let i = this.reconnectTimes;
        let _this = this;
        // 清除之前的定时器
        if (_this.timeOutNum != null) {
          clearTimeout(_this.timeOutNum); //去掉定时器
        }
        // 1,2,3 前三次 1秒重连一次
        if (i <= 3) {
          _this.timeOutNum = setTimeout(() => {
            _this.initWebSocket();
          }, 1000);
        } else if (i <= 6 && i > 3) {
          // 4,5,6 等待30s 30s重连一次
          _this.timeOutNum = setTimeout(() => {
            _this.initWebSocket();
          }, 30000);
        } else if (i > 6) {
          // 7,8,9 等待60s 60s重连一次
          _this.timeOutNum = setTimeout(() => {
            _this.initWebSocket();
          }, 60000);
        }
        // 连接次数 +1
        this.reconnectTimes = ++this.reconnectTimes;
      }
    },
    // updateCallback(val){
    //     if(val == false){
    //         let arr = this.form.moduleTypes.slice(0, this.form.moduleTypes.length-1)
    //         this.form.moduleTypes = arr
    //     }else{
    //         const moduleItem = this.moduleList.filter(ml => ml.moduleType == val.name &&
    //                             ml.moduleVersion == val.version)[0]
    //         if(moduleItem){
    //             const i = this.selectModules.length
    //             let q = parseInt(i / 3)
    //             let r = i % 3
    //             let top  = ((q+1) * 0.02 + q * 0.2) * this.dragRef.height
    //             let left = ((r+1) * 0.02 + r * 0.25) *  this.dragRef.width
    //             this._pushModule(top, left, moduleItem)
    //         }
    //     }
    //     this.updateModuleShow = false
    // },

    // 选择设备回调
    deviceCallback(val) {
      this.showDevice = false
      if (val != false) {
        this.selectModules[this.selectModulesActiveIndex].deviceInstalleds = val.deviceInstalleds
        this.delInsIds = val.delInsIds
      }
    },
    // 设备显示时，触发
    deviceShowCallback(index) {
      this.selectModulesActiveIndex = index
      this.selectedRows = this.selectModules[index].deviceInstalleds
      this.showDevice = true
    },
    // 设备数量删除时触发
    deviceDel() {
      this.insNeedDelShow = true
    },
    startArrangeDriver() {
      this.driver = new this.Driver({
        allowClose: false,
        nextBtnText: '下一步',
        prevBtnText: '上一步',
        doneBtnText: '结束',
        closeBtnText: '关闭'
      });
      this.driver.defineSteps([
        {
          element: '#arrangetype',
          popover: {
            title: '<b>选择编排类型</b>',
            description: '类型有模块和网元<br>',
          }
        }, {
          element: '#arrangeintegration',
          popover: {
            title: '选择集成版本',
            description: '从集成版本里选择模块',
          }
        }, {
          element: '#module',
          popover: {
            title: '选择模块',
            // description: '<img src="' + require("../../assets/files.png") + '" />',
            description: '可选择多个模块，选择的模块在右侧布局区域中'
          }
        }, {
          element: '#layout',
          popover: {
            title: '布局',
            description: '选择的模块会在这儿显示，您可以对模块分配设备、拖动',
            position: 'left'
          }
        }, {
          element: '#layoutDel',
          popover: {
            title: '删除模块',
            description: '将模块拖动到此处，会删除布局中的模块',
            position: 'left'
          }
        }, {
          element: '#checkboxId',
          popover: {
            title: '布局勾选',
            description: '勾选布局后，可对右侧模块拖动，取消勾选，点击右侧模块可以给模块分配设备',
          }
        }, {
          element: '#saveBtn',
          popover: {
            title: '保存',
            description: '布局改变后记得保存',
          }
        }
      ])
      this.driver.start();
    },
    filterIntergrationOption(val) {
      const allOptions = [...this.integrationList]
      if (!val) {
        this.integrationListFilter = allOptions
      } else {
        this.integrationListFilter = allOptions.filter(option => option.alias.toLowerCase().indexOf(val.toLowerCase()) > -1)
      }
    },
    filterModuleList(val) {
      const allOptions = [...this.moduleList]
      if (!val) {
        this.moduleListFilter = allOptions
      } else {
        this.moduleListFilter = allOptions.filter(option => (option.moduleAlias.toLowerCase().indexOf(val.toLowerCase()) > -1))
      }
    }
  }
}
</script>
<style scoped>
.dragDiv {
  /* position: absolute;
  top: 212px;
  bottom: 0;
  left: 0;
  right: 0; */
  clear: both;
}

.container {
  clear: both;
  margin: 0;
  box-sizing: border-box;
  width: 100%;
  height: 100%;
  position: relative;
  overflow: initial;
}

.condition {
  position: absolute;
  width: 30%;
  left: 0;
  top: 0;
}

.collapse {
  cursor: pointer;
  margin-left: 10px;
}
</style>
